// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"842":"0be4b0e5","924":"4f805fce"}[chunkId] + ".chunk.css";
};